import { render, staticRenderFns } from "./promotion_top.vue?vue&type=template&id=4eeac3cb&scoped=true&"
import script from "./promotion_top.vue?vue&type=script&lang=ts&"
export * from "./promotion_top.vue?vue&type=script&lang=ts&"
import style0 from "./promotion_top.vue?vue&type=style&index=0&id=4eeac3cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeac3cb",
  null
  
)

export default component.exports